import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { Pet, Owner, SessionUser } from '../../types';

interface MainLayoutProps {
  children: React.ReactNode;
  user: SessionUser;
  onLogout: () => void;
  onPetSelect?: (pet: Pet & { owner?: Owner }) => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-shell-bg flex min-h-screen flex-col bg-transparent">
      <Header
        user={user}
        onLogout={onLogout}
        onToggleSidebar={() => setSidebarOpen(prev => !prev)}
        sidebarOpen={sidebarOpen}
      />

      <div className="relative flex flex-1 min-h-0 items-stretch">
        {/* Mobil overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-[115] bg-black/40 backdrop-blur-sm lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* İçerik — masaüstünde sidebar kadar margin, mobilde sıfır */}
        <div className="flex min-h-0 flex-1 flex-col lg:ml-[13.5rem]">
          <main className="flex-1 overflow-x-hidden">
            <div className="page-container overflow-x-hidden">{children}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
